import React from 'react';

const renderSelectOptions = (value: string, index: number): JSX.Element => (
  <option key={`${value}-${index}`} value={value}>
    {value}
  </option>
);

export default renderSelectOptions;
